/**
 * @desc PDA查询暂存区
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stagingAreaMaster.pdaDetailList.Params, options?: any) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/pdaDetailList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
